import TransactionStorehousePlace from '@/models/transactionStorehousePlace';

export default class TransactionStorehouse {
  public id: string;
  public name: string;
  public place: TransactionStorehousePlace;

  public constructor(transactionStorehouseProps: any) {
    this.id = transactionStorehouseProps.id;
    this.name = transactionStorehouseProps.name;
    this.place = new TransactionStorehousePlace(transactionStorehouseProps.place);
  }
}
